import cx from 'classnames'
import Card from 'components/lib/Card'
import CardHeader from 'components/lib/CardHeader'
import useMeetingRecipients from 'hooks/useMeetingRecipients'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface MeetingSchedulerCardProps {
  agentId?: number,
  additionalAgents?: any[],
  duration?: number,
  children?: ReactNode
  shouldExpandLayout?: boolean
  showRecipients?: boolean,
  loadingFrame?: boolean
}

const MeetingSchedulerCard = ({
  agentId,
  additionalAgents = [],
  children,
  duration,
  showRecipients = false,
  loadingFrame = false
}: MeetingSchedulerCardProps) => {
  const { t } = useTranslation()
  const meetingRecipients = useMeetingRecipients(agentId, additionalAgents)

  let headerTitle = t('meeting.scheduleAMeeting')

  if (showRecipients) {
    headerTitle = agentId ? `${headerTitle} with ${meetingRecipients}` : headerTitle
  }
  const style = loadingFrame? {} : {"minHeight":"350px"}

  return (
    <Card
      aria-label={headerTitle}
      aria-hidden="true"
      className={cx("drift-meeting-scheduler",{
        'drift-meeting-scheduler--loader': loadingFrame
      })}
      style={style}
    >
      <CardHeader className="drift-meeting-scheduler--header">
        <span>
          {headerTitle}
        </span>
        {duration &&
          <span>{t('meeting.duration', { duration })}</span>
        }
      </CardHeader>
      <div className="drift-meeting-scheduler--content">
        {children}
      </div>
    </Card>
  )
}

export default MeetingSchedulerCard
